import React from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import { FaPhoneAlt, FaMapMarkerAlt, FaCheckCircle, FaBriefcase, FaMoneyBillWave } from "react-icons/fa";

const Recruitment = () => {
  const positions = [
    {
      group: "MAY",
      note: "Nhận đào tạo có lương, cắt chỉ, phụ chuyền may",
      items: [
        { role: "Kỹ thuật", quantity: "2 người" },
        { role: "Công nhân", quantity: "100 người" },
        { role: "Tổ trưởng", quantity: "3 người" },
        { role: "Tổ phó", quantity: "3 người" },
      ],
    },
    {
      group: "ĐÓNG GÓI",
      items: [
        { role: "Công nhân", quantity: "10 người" },
        { role: "Tổ trưởng", quantity: "2 người" },
      ],
    },
    {
      group: "ỦI",
      items: [
        { role: "Công nhân", quantity: "10 người" },
        { role: "Tổ trưởng", quantity: "1 người" },
      ],
    },
    {
      group: "KIỂM TRA CHẤT LƯỢNG SẢN PHẨM",
      items: [
        { role: "QC chuyền", quantity: "10 người" },
        { role: "Bảo trì", quantity: "1 người" },
        { role: "Tạp vụ - nấu ăn", quantity: "2 người" },
      ],
    },
    {
      group: "KẾ TOÁN",
      items: [
        { role: "Kế toán nội bộ", quantity: "1 người" },
      ],
    },
  ];

  return (
    <>
      <Header />

      <main className="bg-slate-50 min-h-screen font-sans">

        {/* <section className="relative bg-slate-900 text-white py-16 md:py-24 overflow-hidden">
          <div
            className="absolute inset-0 opacity-[0.07] pointer-events-none"
            style={{
              backgroundImage: `url("https://images.unsplash.com/photo-1558449028-b53a39d100fc?q=80&w=1600&auto=format&fit=crop' width='160' height='160' viewBox='0 0 160 160'%3E%3Cg fill='none' stroke='%23ffffff' stroke-width='2'%3E%3Ccircle cx='30' cy='30' r='10'/%3E%3Cpath d='M30 40 Q50 60 70 50 T110 70'/%3E%3Cpath d='M120 20 L140 40 M140 20 L120 40'/%3E%3Cpath d='M10 110 Q30 90 50 110 T90 120'/%3E%3Crect x='95' y='95' width='28' height='28' rx='4' transform='rotate(15 109 109)'/%3E%3C/g%3E%3C/svg%3E")`,
              backgroundSize: "320px 320px",
              backgroundRepeat: "repeat",
            }}
          ></div>
          <div className="max-w-5xl mx-auto px-4 text-center relative z-10">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 leading-tight">
              CÔNG TY MAY MẶC THIÊN KIM <br className="md:hidden" /> ĐANG TUYỂN DỤNG!
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto">
              Công việc ổn định quanh năm - Lương thưởng rõ ràng - Nhận việc đi làm ngay.
            </p>
          </div>
        </section> */}

        <section className="relative bg-slate-900 text-white py-16 md:py-24 overflow-hidden">
          {/* Ảnh nền nhà máy/xưởng may chìm lấy trực tiếp từ internet */}
          <div
            className="absolute inset-0 z-0 pointer-events-none"
            style={{
              backgroundImage: `url("https://images.unsplash.com/photo-1558449028-b53a39d100fc?q=80&w=1600&auto=format&fit=crop")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: 0.2, // Đã chỉnh độ mờ tối ưu để chữ trắng hiển thị rõ ràng và đẹp mắt
            }}
          ></div>
          
          {/* Nội dung chữ (Được đẩy nổi lên trên bằng z-10) */}
          <div className="max-w-5xl mx-auto px-4 text-center relative z-10">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 leading-tight">
              CÔNG TY MAY MẶC THIÊN KIM <br className="md:hidden" /> ĐANG TUYỂN DỤNG!
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto">
              Công việc ổn định quanh năm - Lương thưởng rõ ràng - Nhận việc đi làm ngay.
            </p>
          </div>
        </section>

        {/* 2. Cam kết từ công ty */}
        <section className="max-w-4xl mx-auto px-4 -mt-10 relative z-10">
          <div className="bg-white rounded-2xl shadow-xl p-6 md:p-10 border-t-4 border-amber-500 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-4">
              Cam Kết Từ Ban Giám Đốc Công Ty
            </h2>
            <p className="text-lg text-slate-700 leading-relaxed max-w-3xl mx-auto">
              "Chúng tôi hiểu rằng anh chị em công nhân đi làm quan trọng nhất là <strong className="text-amber-600">thu nhập và sự ổn định</strong>. Thiên Kim cam kết luôn đảm bảo công việc đều đặn, <strong className="text-red-600">trả lương sòng phẳng đúng ngày 100%</strong>, và luôn sẵn sàng hỗ trợ khó khăn để mọi người yên tâm gắn bó lâu dài."
            </p>
          </div>
        </section>

        {/* 2.5 Thu nhập & Lương */}
        <section className="max-w-5xl mx-auto px-4 py-10 relative z-10">
          <div className="grid grid-cols-1 gap-5">
            <div className="relative bg-white border border-slate-200 rounded-xl p-6 flex items-center gap-4 shadow-sm overflow-hidden">
              <FaMoneyBillWave className="absolute -right-4 -bottom-4 text-9xl text-green-50" />
              <div className="relative w-14 h-14 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 text-2xl">
                <FaMoneyBillWave />
              </div>
              <div className="relative">
                <h3 className="font-bold text-lg text-slate-800">Tổng thu nhập</h3>
                <p className="text-2xl font-extrabold text-green-600">8 - 18 triệu / tháng</p>
                <p className="text-sm text-slate-500 mt-1">Tùy vị trí, năng suất &amp; tay nghề</p>
              </div>
            </div>
          </div>
        </section>

        {/* 3. Vị trí tuyển dụng */}
        <section className="max-w-6xl mx-auto px-4 py-12">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-slate-900 mb-2">
              Các Vị Trí Đang Cần Tuyển
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {positions.map((group, gIndex) => (
              <div
                key={gIndex}
                className="bg-white border border-slate-200 rounded-xl p-4 hover:border-amber-500 hover:shadow-lg transition"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 text-lg">
                    <FaBriefcase />
                  </div>
                  <h3 className="font-bold text-base text-slate-800 uppercase leading-tight">
                    {group.group}
                  </h3>
                </div>

                {group.note && (
                  <p className="text-xs text-slate-500 italic mb-3">{group.note}</p>
                )}

                <ul className="space-y-2">
                  {group.items.map((item, iIndex) => (
                    <li
                      key={iIndex}
                      className="flex justify-between items-center text-sm text-slate-700"
                    >
                      <span className="flex items-center gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-amber-500 shrink-0"></span>
                        {item.role}
                      </span>
                      <span className="font-bold text-amber-600 whitespace-nowrap ml-2">{item.quantity}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* 4. Quyền lợi */}
        <section className="bg-white py-16 border-t border-slate-200">
          <div className="max-w-5xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-center text-slate-900 mb-10">
              Quyền Lợi Của Bạn
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
              {[
                "Lương chính thức lãnh vào ngày 15 hàng tháng",
                "Tiền tăng ca tính đúng luật (X1.5 ngày thường, X2 Chủ nhật)",
                "Bao cơm trưa miễn phí tại xưởng",
                // "Đóng đầy đủ Bảo Hiểm (BHXH, BHYT) theo luật",
                "Có tiền thưởng Lễ, Tết, lương tháng 13",
                "Xưởng mát mẻ, sạch sẽ, máy móc hiện đại",
                "Thường xuyên được hướng dẫn nâng cao tay nghề",
                "Được hỗ trợ khi ốm đau, thai sản"
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
                  <FaCheckCircle className="text-green-500 text-xl mt-1 shrink-0" />
                  <span className="text-slate-700 text-lg font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 5. Liên hệ */}
        <section className="bg-slate-100 py-16">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-2xl font-bold text-slate-900 mb-8">
              Đăng Ký Đi Làm Ngay!
            </h2>
            
            <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-10">
              {/* Nút Gọi điện */}
              <a 
                href="tel:0912747198"
                className="w-full md:w-auto flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white text-xl font-bold py-4 px-8 rounded-full shadow-lg transition transform hover:scale-105"
              >
                <FaPhoneAlt /> Gọi Ngay: 0912 747 198
              </a>
              
              {/* Nút Zalo */}
              <a 
                href="https://zalo.me/0912747198" 
                target="_blank" 
                rel="noreferrer"
                className="w-full md:w-auto flex items-center justify-center gap-3 bg-blue-500 hover:bg-blue-600 text-white text-xl font-bold py-4 px-8 rounded-full shadow-lg transition transform hover:scale-105"
              >
                Nhắn tin Zalo
              </a>
            </div>

            {/* Địa chỉ */}
            <div className="bg-white rounded-xl shadow-md p-6 inline-block text-left border border-slate-200 w-full max-w-lg mx-auto">
              <div className="flex items-start gap-4">
                <FaMapMarkerAlt className="text-amber-500 text-3xl mt-1 shrink-0" />
                <div>
                  <h3 className="font-bold text-slate-900 text-lg mb-1">Nộp hồ sơ trực tiếp tại:</h3>
                  <p className="text-slate-600 text-lg leading-relaxed">
                    Thửa 7887, Khu phố Tây A, Phường Đông Hòa, Thành phố Hồ Chí Minh.
                  </p>
                  <p className="text-slate-500 mt-2 text-sm italic">
                    (Vui lòng mang theo CMND/CCCD khi đến phỏng vấn)
                  </p>
                </div>
              </div>
            </div>
            
          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Recruitment;